module.exports = __webpack_public_path__ + "img/logo_white.bcce6189.svg";